export default __webpack_public_path__ + "static/headstand-fullheadstand-header-8fb2071a04dfcc3cf8ea498763445b0f.png";